import React from 'react';
import styled from '@emotion/styled';
import { Loader as UiLoader, theme } from '@ublend-npm/aulaui-next';

export const LoadingLabel = styled.span`
  color: ${theme.color.designSystem.grey50};
  font-size: 12px;
  line-height: 12px;
`;

// eslint-disable-next-line react/require-default-props
export const Loader = (props: { progress?: number; color?: string }) => (
  <UiLoader {...props} thickness={7} />
);

export const BackgroundLoader = styled(Loader)`
  position: absolute;
`;

export const Loaders = styled.div`
  display: relative;
`;

export const LoadingGroup = styled.div`
  display: flex;
  flex-direction: column;
`;
